import React, { useMemo } from 'react'
import { useTranslate } from 'react-admin'
import {
  Tab as TabMUI,
  Box,
  Typography,
  Divider,
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { styled } from '@mui/material/styles'
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AvTimerIcon from '@mui/icons-material/AvTimer'
import { B2Icons } from 'src/components/layouts/layoutTopNav/B2Icons'
import { LinearScale, VerticalScale } from 'src/components/uiElements/iconCSS/IconCSS'
import { AirSegmentIcon } from 'src/components/pages/sales/reservation/logic/air/AirIcons'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import { turquoise, lightcyan, blue } from 'src/assets/colors'
import { useImage } from 'src/components/customHooks/useImage'
import { formatDate } from '../../../business-rule/helper/formatDate'

const Accordion = styled((props) => <MuiAccordion {...props} />)(() => ({
  '&:before': {
    display: 'none',
  },
}))

export const GetLogoImageAirline = React.memo(({ fileName, style }) => {
  const extensions = useMemo(() => ['png', 'jpg', 'jpeg', 'gif'], [])
  const { loading, error, image } = useImage({ fileName, extensions })
  if (error) return null
  return <>{loading ? <Typography>loading</Typography> : <img style={style} src={image} alt={fileName} />}</>
})

export const getAirports = (list) => {
  if (list && Array.isArray(list) && list.length !== 0) {
    let listAirports = list.map((data) => `${data.boardPoint}/${data.offPoint} - `)
    let concant = listAirports.join('')
    let delete_last_characters = concant?.slice(0, -2)
    return delete_last_characters
  }
}

export const AirScaleRow = ({ air }) => {
  const translate = useTranslate()
  const { itineraryGroup } = air.segments?.[0] || {}
  const { baggage } = air

  const logicCheckLuggage = (baggages, index, nameLuggageKey) => {
    if (baggages && baggages.length !== 0 && baggages[index]) {
      if (baggages[index]?.ADT?.[nameLuggageKey] >= 1) {
        return true
      }
    }
    return false
  }

  const hasDispatchBaggage = (baggages, index) => {
    return logicCheckLuggage(baggages, index, 'Pieces')
  }

  const hasCarryOn = (baggages, index) => {
    return logicCheckLuggage(baggages, index, 'CarryOn')
  }

  const hasBackPack = (baggages, index) => {
    return logicCheckLuggage(baggages, index, 'Handbag')
  }

  const howManyScales = (amount_scale) => {
    if (amount_scale === 0)
      return (
        <>
          <Typography
            component='div'
            style={{
              color: turquoise,
              fontWeight: 600,
              marginBottom: '5px',
            }}
          >
            {translate('ra.title.direct')}
          </Typography>
          <LinearScale />
        </>
      )
    if (amount_scale !== 0)
      return (
        <>
          <Typography
            component='div'
            style={{
              color: turquoise,
              fontWeight: 600,
              marginBottom: '5px',
            }}
          >
            {amount_scale} {translate('ra.title.scale')}
          </Typography>
          <LinearScale direct classToUse={amount_scale} />
        </>
      )
  }

  return (
    <Box style={{ width: '100%', height: 'auto', margin: '15px 0 15px 0' }}>
      <Typography variant='h6' component='span' color={blue} padding={'0px 5px 0px 5px'}>
        {translate('ra.title.segments')} ({itineraryGroup?.length})
      </Typography>

      <TabContext value={'1'}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList aria-label='lab API tabs example'>
            <TabMUI label={getAirports(itineraryGroup)} value='1' />
          </TabList>
        </Box>

        <TabPanel value='1'>
          {itineraryGroup?.map((flightInformation, index) => {
            return (
              <Accordion
                key={index}
                style={{
                  boxShadow: 'none',
                  backgroundColor: lightcyan,
                  borderRadius: '10px',
                  margin: '10px 0 10px 0',
                }}
                //expanded={true}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls='panel1a-content'
                  id='panel1a-header'
                >
                  <Box className='accordion_summary_container'>
                    {itineraryGroup?.length <= 2 && index === 0 ? (
                      <AirSegmentIcon
                        style={{ transform: 'rotate(90deg)' }}
                        icon={<AirplanemodeActiveIcon />}
                        text={translate('ra.title.going')}
                      />
                    ) : itineraryGroup?.length <= 2 && index === 1 ? (
                      <AirSegmentIcon
                        style={{ transform: 'rotate(-90deg)', margin: '0 0 0 7px' }}
                        icon={<AirplanemodeActiveIcon />}
                        text={translate('ra.title.return')}
                      />
                    ) : undefined}
                    <Box display={'flex'}>
                      <Box className='accordion_summary_column' position={'relative'}>
                        <Typography
                          variant='h6'
                          component='div'
                          className='accordion_summary_column_absolute'
                        >
                          {translate('ra.title.segment')} {index + 1}
                        </Typography>
                        <Box
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          <GetLogoImageAirline
                            fileName={flightInformation?.airline || undefined}
                            style={{ height: '25px', width: 'auto' }}
                          />
                        </Box>
                      </Box>
                      <Box className='accordion_summary_column'>
                        <Typography component='div'>{translate('ra.title.departure')}</Typography>
                        <Typography
                          variant='h7'
                          component='div'
                          style={{
                            fontWeight: 600,
                          }}
                        >
                          {flightInformation.boardPoint}
                        </Typography>
                        <Typography
                          component='div'
                          style={{
                            color: blue,
                          }}
                        >
                          {formatDate(flightInformation.departureDate)}
                        </Typography>
                        <Typography
                          component='div'
                          style={{
                            color: blue,
                          }}
                        >
                          {flightInformation.departureTime?.slice(0, 5) || 'aaaaaaaaaa'}
                        </Typography>
                      </Box>
                      <Box className='accordion_summary_column'>
                        {howManyScales(flightInformation?.scales?.length - 1)}
                      </Box>
                      <Box className='accordion_summary_column'>
                        <Typography component='div'>{translate('ra.title.arrival')}</Typography>
                        <Typography
                          component='div'
                          style={{
                            fontWeight: 600,
                          }}
                        >
                          {flightInformation.offPoint}
                        </Typography>
                        <Typography
                          variant='h7'
                          component='div'
                          style={{
                            color: blue,
                          }}
                        >
                          {formatDate(flightInformation.arrivalDate)}
                        </Typography>
                        <Typography
                          variant='h7'
                          component='div'
                          style={{
                            color: blue,
                          }}
                        >
                          {flightInformation.arrivalTime?.slice(0, 5)}
                        </Typography>
                      </Box>
                      <Box className='accordion_summary_column'>
                        <Typography
                          component='div'
                          style={{
                            fontWeight: 600,
                          }}
                        >
                          {translate('ra.title.duration')}
                        </Typography>

                        <Typography component='div' style={{ textAlign: 'center' }}>
                          {flightInformation.totalDuration}
                        </Typography>
                      </Box>
                      <Box className='accordion_summary_column'>
                        <Box color={turquoise} height={'30px'} width={'auto'}>
                          {hasBackPack(baggage, index) ? (
                            <B2Icons
                              style={{ width: 'auto', height: '15px' }}
                              icon='equipaje-mano'
                              alt='equipaje-mano'
                            />
                          ) : undefined}
                          {hasCarryOn(baggage, index) ? (
                            <B2Icons
                              style={{ width: 'auto', height: '25px' }}
                              icon='equipaje-cabina'
                              alt='equipaje-mano'
                            />
                          ) : undefined}
                          {hasDispatchBaggage(baggage, index) ? (
                            <B2Icons
                              style={{ width: 'auto', height: '25px' }}
                              icon='equipaje-despachado'
                              alt='equipaje-despachado'
                            />
                          ) : undefined}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  {flightInformation?.scales && flightInformation.scales.length >= 1
                    ? flightInformation.scales.map((scale, index) => {
                        return (
                          <Box margin={'10px 0 10px 0'} key={index}>
                            {index !== 0 ? (
                              <Box className='accordion_details_scale'>
                                <Typography component='div' className='number_scale'>
                                  {translate('ra.title.scale')} {index}
                                </Typography>
                                <Box className='wait_info_scale'>
                                  <AvTimerIcon />
                                  <Typography component='div' color={turquoise} fontWeight={600}>
                                    {translate('ra.title.wait_in')} {scale.boardPointName} (
                                    {scale.boardPointCityCode}) - {scale.waitTime}
                                  </Typography>
                                </Box>
                              </Box>
                            ) : undefined}
                            <Box className='accordion_details_scale_detail'>
                              <Box className='accordion_details_scale_detail_container'>
                                <Box className='accordion_details_scale_detail_segment_icon'>
                                  <VerticalScale />
                                </Box>
                                <Box className='accordion_details_scale_detail_segment'>
                                  <Box className='airport_detail'>
                                    <Typography component='span' color={blue} fontWeight={600}>
                                      {scale.boardPoint}
                                    </Typography>
                                    <Typography component='span' color={turquoise} fontWeight={600}>
                                      {formatDate(scale.departureDate)}
                                    </Typography>
                                    <Typography component='span' color={turquoise} fontWeight={600}>
                                      {scale.departureTime}
                                    </Typography>
                                    <Typography
                                      component='div'
                                      fontWeight={600}
                                      width={'100%'}
                                      textAlign={'center'}
                                    >
                                      {scale.boardPointName}
                                    </Typography>
                                  </Box>
                                  <Box className='airport_detail'>
                                    <Typography component='span' color={blue} fontWeight={600}>
                                      {scale.offPoint}
                                    </Typography>
                                    <Typography component='span' color={turquoise} fontWeight={600}>
                                      {formatDate(scale.arrivalDate)}
                                    </Typography>
                                    <Typography component='span' color={turquoise} fontWeight={600}>
                                      {scale.arrivalTime}
                                    </Typography>
                                    <Typography
                                      fontWeight={600}
                                      component='div'
                                      width={'100%'}
                                      textAlign={'center'}
                                    >
                                      {scale.offPointName}
                                    </Typography>
                                  </Box>
                                </Box>
                                <Box
                                  className='accordion_details_scale_detail_segment'
                                  display={'flex'}
                                  padding={'0 5px 0 5px'}
                                >
                                  <Box className='flight_detail'>
                                    <ShowElement
                                      data={scale.operatingCompany}
                                      label={translate('ra.field.operator_company')}
                                    />
                                    <ShowElement
                                      data={scale.bookingClass}
                                      label={translate('ra.field.booking_class')}
                                    />
                                    <ShowElement
                                      data={scale.flightNumber}
                                      label={translate('ra.field.flight')}
                                    />
                                  </Box>
                                  <Box className='flight_detail'>
                                    <ShowElement
                                      data={scale.marketingCompany}
                                      label={translate('ra.field.airline')}
                                    />
                                    <ShowElement
                                      data={scale.equipmentType}
                                      label={translate('ra.field.equipmentType')}
                                    />
                                    <ShowElement data={scale.Cabin} label={translate('ra.field.Cabin')} />
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        )
                      })
                    : undefined}
                  {/* luggage */}
                  {baggage && baggage.length !== 0
                    ? Object.keys(baggage[index]).map((item, key) => {
                        return (
                          <Box key={key} className='baggage_container'>
                            <Typography component='div' className='baggage_luggage'>
                              {translate('ra.title.luggage')} ({baggage[index]?.[item].PPP})
                            </Typography>
                            <Box className='baggage_info'>
                              <ShowElement
                                data={baggage[index]?.[item].PPP}
                                label={'PPP'}
                                style={{ width: '250px' }}
                              />
                              <ShowElement
                                data={baggage[index]?.[item].CarryOnWeight}
                                label={translate('ra.field.carryOnWeight')}
                                style={{ width: '250px' }}
                              />
                              <ShowElement
                                data={baggage[index]?.[item].Weight}
                                label={translate('ra.field.weight')}
                                style={{ width: '250px' }}
                              />
                              <ShowElement
                                data={baggage[index]?.[item].CarryOn}
                                label={'CarryOn'}
                                boolean
                                style={{ width: '250px' }}
                              />
                              <ShowElement
                                data={baggage[index]?.[item].Handbag}
                                label={translate('ra.field.handbag')}
                                boolean
                                style={{ width: '250px' }}
                              />
                              <ShowElement
                                data={baggage[index]?.[item].Unit}
                                label={translate('ra.field.unit')}
                                style={{ width: '250px' }}
                              />
                            </Box>
                          </Box>
                        )
                      })
                    : undefined}
                </AccordionDetails>
              </Accordion>
            )
          })}
        </TabPanel>
      </TabContext>
      <Divider />
    </Box>
  )
}
